<script setup lang="ts">
import AppHeaderBarGuest from '@/components/default-customer/app-header-bar-guest.vue'
import AppHeaderBarGuestTG from '@/components/tg/app-header-bar-guest.vue'
import AppHeaderBarGuestSH from '@/components/sh/app-header-bar-guest.vue'
import KpFooter from '@/components/default-customer/app-footer.vue'
import KpFooterTG from '@/components/tg/app-footer.vue'
import KpFooterSH from '@/components/sh/app-footer.vue'
import { computed } from 'vue'
import { useGlobals } from '@/helpers/globals'

const customer = computed(() => useGlobals().customer)
</script>

<template>
    <v-app id="guest-app">
        <AppHeaderBarGuest v-if="$route.name !== 'welcome' && customer === 'default'" app />
        <AppHeaderBarGuestTG v-if="$route.name !== 'welcome' && customer === 'tg'" app />
        <AppHeaderBarGuestSH v-if="$route.name !== 'welcome' && customer === 'sh'" app />
        <v-main class="white lighten-2">
            <RouterView />
        </v-main>
        <KpFooter v-if="customer === 'default'" app />
        <KpFooterTG v-if="customer === 'tg'" app />
        <KpFooterSH v-if="customer === 'sh'" app />
    </v-app>
</template>
